import { Sticky } from 'semantic-ui-react';

export default Sticky;
